"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureFileManager;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = require("immutable");

var _reactRedux = require("react-redux");

var _Auth = require("FileManagerCore/actions/Auth");

var _Actions = require("../actions/Actions");

var _configureStore = _interopRequireDefault(require("../utils/redux/configureStore"));

var _logging = require("FileManagerCore/utils/logging");

var _validateFileAccess = require("../utils/validateFileAccess");

var configureCalled = false;

function configureFileManager(_ref) {
  var httpClient = _ref.httpClient,
      usageTracker = _ref.usageTracker,
      _ref$specificCanvaTem = _ref.specificCanvaTemplates,
      specificCanvaTemplates = _ref$specificCanvaTem === void 0 ? null : _ref$specificCanvaTem,
      _ref$withCanva = _ref.withCanva,
      withCanva = _ref$withCanva === void 0 ? false : _ref$withCanva,
      _ref$withShutterstock = _ref.withShutterstock,
      withShutterstock = _ref$withShutterstock === void 0 ? false : _ref$withShutterstock,
      uploadedFileAccess = _ref.uploadedFileAccess;

  if (!(0, _validateFileAccess.getIsConfigureFileManagerFileAccessValid)(uploadedFileAccess)) {
    throw new Error('[FileManagerLib/configureFileManager] Specify file visibility in your configureFileManager function. Visit https://product.hubteam.com/docs/file-manager-manual/Frontend/index.html for details.');
  }

  if (configureCalled) {
    console.warn('[FileManagerLib/configureFileManager] should only be called once and was already called.');
    (0, _logging.logNewRelicPageAction)('warn-multiple-configureFileManager-calls');
  }

  var store = (0, _configureStore.default)({
    configuration: (0, _immutable.Map)({
      specificCanvaTemplates: specificCanvaTemplates,
      withCanva: withCanva,
      withShutterstock: withShutterstock,
      hostApp: (0, _logging.getCurrentApp)(),
      uploadedFileAccess: uploadedFileAccess
    })
  }, {
    httpClient: httpClient,
    usageTracker: usageTracker
  });
  configureCalled = true;

  var FileManager = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(FileManager, _Component);

    function FileManager(props) {
      var _this;

      (0, _classCallCheck2.default)(this, FileManager);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FileManager).call(this, props));
      FileManager.dispatch((0, _Auth.setAuth)(props.auth));
      return _this;
    }

    (0, _createClass2.default)(FileManager, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        FileManager.dispatch((0, _Actions.libComponentDidMount)());
      }
    }, {
      key: "componentDidCatch",
      value: function componentDidCatch(error) {
        (0, _logging.logNewRelicError)(error, {
          errorBoundary: true
        });
        console.error('[FileManagerLib] hit error boundary', error);
      }
    }, {
      key: "render",
      value: function render() {
        var children = this.props.children;
        return _react.default.createElement(_reactRedux.Provider, {
          store: store
        }, children);
      }
    }]);
    return FileManager;
  }(_react.Component);

  FileManager.propTypes = {
    auth: _propTypes.default.object.isRequired,
    children: _propTypes.default.node.isRequired
  };
  FileManager.dispatch = store.dispatch;
  FileManager.getState = store.getState;
  return FileManager;
}

module.exports = exports.default;